// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LockOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M55.444 54.757a7.437 7.437 0 0 1-4.607 6.874v7.835a2.84 2.84 0 0 1-2.843 2.826 2.831 2.831 0 0 1-2.825-2.826v-7.834a7.433 7.433 0 0 1-4.602-6.875A7.43 7.43 0 0 1 48 47.323c4.108 0 7.444 3.325 7.444 7.434Zm20.498 26.496a2.25 2.25 0 0 1-2.247 2.247H22.31a2.252 2.252 0 0 1-2.253-2.247V38.368a2.254 2.254 0 0 1 2.253-2.252h51.383a2.252 2.252 0 0 1 2.248 2.252v42.885ZM30.1 30.399c0-9.87 8.03-17.899 17.9-17.899S65.9 20.529 65.9 30.399v1.717H30.1v-1.717Zm43.594 1.717H69.9v-1.717C69.9 18.324 60.075 8.5 48 8.5s-21.9 9.824-21.9 21.899v1.717h-3.79a6.259 6.259 0 0 0-6.252 6.252v42.885c0 3.444 2.805 6.247 6.253 6.247h51.383a6.255 6.255 0 0 0 6.248-6.247V38.368c0-3.447-2.803-6.252-6.247-6.252Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default LockOutline;
